module.exports = require("jsurl");